export default __webpack_public_path__ + "static/media/stories-image-5.631af398.png";